var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobile)?_c('mobile-control'):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('pc-control'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/footer/index.vue?vue&type=template&id=7f936f98
// module id = null
// module chunks = 